import { render, staticRenderFns } from "./OrganizationsInfo.vue?vue&type=template&id=735ac875&scoped=true"
import script from "./OrganizationsInfo.vue?vue&type=script&lang=js"
export * from "./OrganizationsInfo.vue?vue&type=script&lang=js"
import style0 from "./OrganizationsInfo.vue?vue&type=style&index=0&id=735ac875&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "735ac875",
  null
  
)

export default component.exports